import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import clsx from 'clsx';
import { AlertBanner } from 'acq-components/lib/composite-components/Banner/Variations/AlertBanner';
import AlertBannerStyles from './__styles__/index.scss?modules';
import { getAlertBannerData } from './redux';

export const AlertBannerComponent = React.memo(
  ({
    classname = 'alertBanner',
    maxWidth = '986px',
    styles = AlertBannerStyles,
    shouldRender,
    ...props
  }) =>
    shouldRender && (
      <AlertBanner
        classname={clsx(classname, styles[`maxWidth${maxWidth}`])}
        styles={styles}
        {...props}
      />
    )
);

const mapStateToProps = state => ({
  ...getAlertBannerData(state)
});

export default connect(mapStateToProps)(AlertBannerComponent);

AlertBanner.propTypes = {
  primaryHeadline: PropTypes.string,
  secondaryHeadline: PropTypes.string,
  classname: PropTypes.string,
  styles: PropTypes.objectOf(PropTypes.string),
  onClose: PropTypes.func,
  maxWidth: PropTypes.num,
  shouldRender: PropTypes.bool
};
